module.exports = __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-daf82581c5ea8b54dd6e3db2129e7ae8.woff";